<template>
    <div class="main">
        <a-card :loading="tableLoading" style="border-radius: 20px;" :bordered="false">

            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Regions</h3>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">

                <a-button @click="showRegionModal"
                    style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
                    icon="plus">
                    Add New Region
                </a-button>
            </div>
            <div>
                <a-table :columns="regionColumns" :data-source="regions" :loading="tableLoading"
                    :pagination="pagination" class="tableStyle">
                    <div slot="filterDropdown"
                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                        style="padding: 8px">
                        <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                            Search
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                            Reset
                        </a-button>
                    </div>
                    <div slot="filterStatusDropdown" slot-scope="{ clearFilters }"
                        style="padding: 8px;display: flex;flex-direction: column;">
                        <a-select style="width: 190px" @change="e => onInventoryChange(e, clearFilters)">
                            <a-select-option value="all">
                                All
                            </a-select-option>
                            <a-select-option value="1">
                                Enabled
                            </a-select-option>
                            <a-select-option value="0">
                                Disabled
                            </a-select-option>
                        </a-select>
                    </div>
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showUpdateRegionModel(data)">Edit Region?</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>


                    <template slot="status" slot-scope="data">
                        <div v-if="data.status === 1">
                            <a-switch default-checked checkedChildren="Enabled" unCheckedChildren="Disabled"
                                @change="supplierOnChange" @click="switchStatus(data)" />
                        </div>
                        <div v-else>
                            <a-switch checkedChildren="Enabled" unCheckedChildren="Disabled" @change="supplierOnChange"
                                @click="switchStatus(data)" />
                        </div>
                    </template>
                </a-table>
            </div>

            <a-modal class="modalStyle" :visible="addRegionVisible" :footer="null" @cancel="handleAddRegionCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Add
                    Region</p>
                <div>
                    <a-form-model ref="addRegionForm" :model="addRegionModel" :rules="rules">
                        <a-form-model-item label="Name" ref="name" prop="name">
                            <a-input class="" v-model="addRegionModel.name" />
                        </a-form-model-item>
                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;">
                            <a-button @click="handleAddRegionSubmit" :loading="loading"
                                style="background: #418a49;color:#fff;border-radius:5px;">
                                Submit
                            </a-button>
                        </a-form-model-item>

                    </a-form-model>
                </div>
            </a-modal>
            <a-modal class="modalStyle" :visible="updateRegionVisible" :footer="null"
                @cancel="handleUpdateRegionCancel">

                <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px;">
                    Edit
                    Region</p>
                <div>
                    <a-form-model ref="updateRegionForm" :model="updateRegionModel" :rules="rules">
                        <a-form-model-item label="Name" ref="name" prop="name">
                            <a-input class="" v-model="updateRegionModel.name" />
                        </a-form-model-item>
                        <a-form-model-item
                            style="display: flex;justify-content: center;align-items: center;">
                            <a-button :loading="loading" @click="handleEditRegionSubmit"
                                style="background: #418a49;color:#fff;border-radius:5px;">
                                Edit Region
                            </a-button>
                        </a-form-model-item>
                    </a-form-model>
                </div>
            </a-modal>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const regionColumns = [
    {
        title: 'ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Region Name',
        // width: 150,
        key: 'name',
        dataIndex: 'name',
        scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
            record.name
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
    },
   
    {
        title: 'Date Added',
        // width: 150,
        key: 'createdAt',
        dataIndex: 'createdAt',
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
    },

]
    export default {
        name: 'Regions',
        data(){
            return{
                tableSupplierData:[],
                tableLoading: false,
                regionColumns,
                pagination: {
                    pageSize:20
                },
                isSupplierEnabled: Boolean,
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                addRegionModel:{
                    name: '',
                },
                updateRegionModel: {
                    name: '',
                },
                regions: [],
                addRegionVisible: false,
                updateRegionVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                selectedRegion:{},
                rules:{
                    notes: [
                        { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                    ],
                    name: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ], 
                }
            }
        },
        computed:{
            ...mapGetters(['IsAgentProfileAvailable']),
        },
        methods:{
            ...mapActions(['getAllProductsMgtData', 'getAllRegion','addRegion','updateRegion']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            showRegionModal(){
                this.addRegionVisible = true;
            },
            supplierOnChange(checked){
                this.isSupplierEnabled = checked
            },
            showUpdateRegionModel(data) {
                this.selectedRegion = data
                this.updateRegionModel.name = data.name
                this.updateRegionVisible = true;
            },
            handleUpdateRegionCancel(){
                this.updateRegionVisible = false;
            },
            handleAddRegionCancel(){
                this.addRegionVisible = false;
            },
             handleAddRegionSubmit(){
                this.$refs.addRegionForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                name:  this.addRegionModel.name,
                            }
 
                            this.addRegion(request).then(response => {
                                this.loading = false;
                                if(response.status === 200){
                                    this.loadRegions();
                                    this.showSuccessAlert("New Region Added Successfully")
                                    this.addRegionVisible = false;
                                    this.$refs.addRegionForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
            handleEditRegionSubmit(){
                this.$refs.updateRegionForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                id: this.selectedRegion.id,
                                data: {
                                    name:  this.updateRegionModel.name,
                                }
                            }
                    
                            this.updateRegion(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.loadRegions();
                                    this.showSuccessAlert("Region Updated Successfully")
                                    this.updateRegionVisible = false;
                                    this.$refs.updateRegionForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
             switchStatus(data){
                this.tableLoading = true
            
                const request = {
                    id: data.id,
                    data: {
                        name:  data.name,
                        address: data.address,
                        metadata:{
                            phoneNumber: data.metadata.phoneNumber,
                            description: data.metadata.description,
                        },
                        status: this.isSupplierEnabled === true ? 1 : 0
                    }
                }
                
                
                this.updateRegion(request).then(response => {
                    
                    this.tableLoading = false;
                    if(response.status === 200){
                        this.getProductsMgtData();
                        if(this.isSupplierEnabled){
                            this.showSuccessAlert(`Supplier [ ${data.name} ] Enabled Successfully`)
                        }else{
                            this.showSuccessAlert(`Supplier [ ${data.name} ] Disabled Successfully`)
                        }
                    }else{
                        this.tableLoading = false;
                        this.showErrorAlert(response.data.messages)
                    }
                },
                error =>{
                    this.tableLoading = false
                    this.showErrorAlert(JSON.stringify(error))
                }) 
            },
            onInventoryChange(value, clearFilters){
                let result = []
                if(value === 'all'){
                    result = this.availableSuppliers
                }else {
                    result = this.availableSuppliers.filter(invoice => parseInt(invoice.status) === parseInt(value) )
                }
                this.tableSupplierData = result.map(supplier => ({
                    id: supplier.id,
                    key: supplier.id,
                    name: supplier.name,
                    address: supplier.address ? supplier.address : 'N/A',
                    status: supplier,
                    isRestricted: supplier.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(supplier.createdAt).format('DD-MM-YYYY'),
                    action: supplier
                }))
                clearFilters();
            },
            getAllSuppliersData(response){
             if(response.status === 200){
                this.availableSuppliers = response.data.data
                this.tableSupplierData = response.data.data.map(supplier => ({
                    id: supplier.id,
                    key: supplier.id,
                    name: supplier.name,
                    address: supplier.address ? supplier.address : 'N/A',
                    status: supplier,
                    isRestricted: supplier.isRestricted === true ? 'Yes' : 'No',
                    dateCreated: moment(supplier.createdAt).format('DD-MM-YYYY'),
                    action: supplier
                }))
                // this.tableCategoryData =  _.orderBy(result, ['dateCreated'],['desc'])
            }else{
                console.log("Error | " , response)
            }
        },
        async getProductsMgtData(){
            this.tableLoading =  true;
            const response = await this.getAllProductsMgtData();
            this.getAllSuppliersData(response[2])
        
            this.tableLoading =  false;
            },
            async loadRegions() {
                this.tableLoading = true;
                const response = await this.getAllRegion();
                this.regions = response.data.data.map(item => ({
                    ...item,
                    key: item.id,
                    createdAt: item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD') : "N/A",
                    action: item
                }));
                this.tableLoading = false;
            },
         
    },

        created() {
            this.loadRegions();
        }
    }
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.orderTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.orderTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #418a49;
}

a:hover {
    color: #418a49;
}

.orderTable>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>